import { postContact } from './action';

export { watchContacts } from './saga';
export { POST_CONTACT } from './types';

export const contactAction = {
  postContact,
};
